<section>
  <app-form-header
    [menuDefinition]="menuDefinition"
    [contextInfo]="
      titleContextInfo
        ? titleContextInfo + (isTitleContextEdited ? ' (' + ('USERGROUP.CONTEXT_EDITED' | translate) + ')' : '')
        : ''
    "
    (onSave)="onSubmit()"
    (onCancel)="cancel()"
  ></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [useSurfaceErrorPadding]="true">
          <astral-input [control]="form.controls['name']"></astral-input>
        </astral-layout-group>
      </section>
      @if (showConfidentialErrandAccessToggle) {
        <section class="astral-section-surface astral-stack-m">
          <h3 class="astral-section-heading">{{ 'MODULE.NAMES.COMMON' | translate }}</h3>
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
            <astral-toggle [control]="form.controls['hasConfidentialErrandAccess']"></astral-toggle>
          </astral-layout-group>
        </section>
      }
      @for (module of standardModules; track module) {
        <section class="astral-section-surface astral-stack-m">
          <h3 class="astral-section-heading">{{ 'MODULE.NAMES.' + module.name.toUpperCase() | translate }}</h3>
          @if (module.name.toUpperCase() === 'ERRANDS') {
            <div class="restricted-errand-access-info" role="note">
              <i class="fa-light fa-circle-info" aria-hidden="true"></i>
              <p>{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.INFO' | translate }}</p>
            </div>
            @if (dataContext.id) {
              <div class="restricted-errand-access-summary">
                <div class="restricted-errand-access-summary__content">
                  <h4>{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.HEADER' | translate }}</h4>
                  @if (assignedAccessRestrictions.length === 0) {
                    <p>{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.NO_ACCESS' | translate }}</p>
                  } @else {
                    <p>
                      {{ activeAccessRestrictionCount }} {{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.ACTIVE' | translate }},
                      {{ inactiveAccessRestrictionCount }} {{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.INACTIVE' | translate }}
                    </p>
                  }
                </div>
                @if (assignedAccessRestrictions.length > 0) {
                  <astral-button
                    type="button"
                    variant="secondary"
                    size="small"
                    labelKey="USERGROUP.RESTRICTED_ERRAND_ACCESS.VIEW"
                    (click)="openAccessRestrictionsDialog()"
                  ></astral-button>
                }
              </div>
            }
          }
          @if (module.name === protectedIdentityModuleName) {
            <app-information-block text="USERGROUP.PROTECTED_IDENTITY_INFO"></app-information-block>
          }
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
            @for (feature of module.features; track feature) {
              <astral-toggle [control]="form.controls[feature]"></astral-toggle>
            }
          </astral-layout-group>
        </section>
      }
      @if (publicApiModules.length > 0) {
        <section class="public-api-section astral-stack-m">
          <div class="public-api-section__intro astral-stack-s">
            <hr class="public-api-divider" />
            <h2 class="public-api-heading astral-section-heading">{{ 'USERGROUP.API_ACCESS_HEADER' | translate }}</h2>
          </div>
          @for (module of publicApiModules; track module) {
            <section class="astral-section-surface astral-stack-m">
              <h3 class="astral-section-heading">{{ 'MODULE.NAMES.' + module.name.toUpperCase() | translate }}</h3>
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
                @for (feature of module.features; track feature) {
                  <astral-toggle [control]="form.controls[feature]"></astral-toggle>
                }
              </astral-layout-group>
            </section>
          }
        </section>
      }
    </form>
  }
</section>

@if (accessRestrictionsDialogOpen) {
  <astral-dialog
    [closeOnBackdrop]="true"
    [open]="true"
    size="large"
    titleKey="USERGROUP.RESTRICTED_ERRAND_ACCESS.DIALOG_HEADER"
    (closed)="closeAccessRestrictionsDialog()"
  >
    <p>{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.DIALOG_INFO' | translate }}</p>
    @if (assignedAccessRestrictions.length === 0) {
      <p>{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.NO_ACCESS' | translate }}</p>
    } @else {
      <div class="restricted-errand-access-table-wrapper">
        <table class="table restricted-errand-access-table">
          <thead>
            <tr>
              <th scope="col">{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.RESTRICTION_COLUMN' | translate }}</th>
              <th scope="col">{{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.STATUS_COLUMN' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (restriction of assignedAccessRestrictions; track restriction.id) {
              <tr>
                <td>{{ restriction.name }}</td>
                <td>
                  @if (restriction.isEnabled) {
                    <span class="restricted-errand-access-status restricted-errand-access-status--active">
                      {{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.ACTIVE_STATUS' | translate }}
                    </span>
                  } @else {
                    <span class="restricted-errand-access-status restricted-errand-access-status--inactive">
                      {{ 'USERGROUP.RESTRICTED_ERRAND_ACCESS.INACTIVE_STATUS' | translate }}
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <astral-button
      astralDialogActions
      type="button"
      variant="secondary"
      labelKey="CLOSE_BTN"
      (click)="closeAccessRestrictionsDialog()"
    ></astral-button>
  </astral-dialog>
}
